import {
  REQUEST_PROFILE,
  RECEIVE_PROFILE,
  PROFILE_ERROR
} from "../actions/profile";

function currentUser(state = { status: "loading" }, action) {
  switch (action.type) {
    case REQUEST_PROFILE:
      return Object.assign({}, state, {
        status: "loading"
      });
    case RECEIVE_PROFILE:
      return {
        id: action.user.id,
        status: "success"
      };
    case PROFILE_ERROR:
      return Object.assign({}, state, {
        status: "Error fetching your profile"
      });
    default:
      return state;
  }
}
export default currentUser;



// WEBPACK FOOTER //
// ./src/reducers/currentUser.js